import { defineMessages } from 'react-intl';

export default defineMessages({
    removeTitle:{
        "id":"certificatesofinsurance.remove.Confirm Certificate Deletion",
        "defaultMessage":"Confirm Certificate Deletion"
    },
    removeMessage:{
        "id":"certificatesofinsurance.remove.Are you sure you want to delete the selected certificates?",
        "defaultMessage":"Are you sure you want to delete the selected certificates?"
    },
    certsDeletedMessage:{
        "id":"certificatesofinsurance.remove.Deleted Certificate {id} for {holdername}.",
        "defaultMessage":"Deleted Certificate {id} for {holdername}."
    },
    Title:{
        "id":"certificatesofinsurance.create.Error entering Input",
        "defaultMessage":"Input Field Error"

    },
    errorMessage:{
        "id":"certificatesofinsurance.create.Error entering Input message",
        "defaultMessage":"Please enter all the mandatory fields to proceed further"
    }
});